import cxs from 'cxs';

export const PHONE_NUMBER_INPUT = cxs({
  ' input[type=number]': {
    paddingLeft: '10px !important'
  },

  ' input[type=number]::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },

  'input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  }
});